import React, { useEffect, useState } from "react";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
  HeadingStyledSm,
  SpanStyled,
} from "../../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import {
  BackArrow,
  BackwardArrow,
  ForwardArrow,
  LocationPin,
  PlusIcon,
  ThreeDots,
  Whatsapp,
} from "../../../../components/styled/AllImages";
import {
  lookingForDropdownList,
  PropertyDropdownList,
} from "../../../../helpers/webConstants";
import ActionDropdown from "../../../../components/common/dropdowns/ActionDropdown";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // Core Swiper styles
import "swiper/css/navigation"; // Navigation styles (optional)
import "swiper/css/pagination"; // Pagination styles (optional)

// Import additional modules if needed
import { Pagination, Autoplay } from "swiper/modules";
import AddPropertyModal from "../../../../components/auth/Modal/AddPropertyModal";
import EditPropertyModal from "../../../../components/auth/Modal/EditPropertyModal";
import PropertiesApi from "../../../../services/api/propertiesApi";
import DeleteModal from "../../../../components/auth/Modal/DeleteModal";
import { toast } from "react-toastify";
import AddLookingForModal from "../../../../components/auth/Modal/AddLookingForModal";
import EditLookingForModal from "../../../../components/auth/Modal/EditLookingForModal";
import { formateAmounts } from "../../../../utils";
import {
  buildAdvertiserRoleOptions,
  resolveAdvertiserRoleLabel,
} from "../../../../utils/advertiserRoles";
import { useUser } from "../../../../context/userContext";

const LookingForCards = ({ showAll, setShowAll }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { user } = useUser();
  const isVisitorSpecialization =
    Number(user?.fal_information?.specialization) === 4;
  const [isDesktop, setIsDesktop] = useState(window.innerWidth < 767);
  const [propertiesList, setPropertiesList] = useState([]);
  const [propertyId, setPropertyId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [advertiserTypes, setAdvertiserTypes] = useState([]);

  const [isFetching, setIsFetching] = useState(false);

  // Open & Close Modal
  const handleOpenModal = (id) => {
    setPropertyId(id);
    setShowEditModal(true);
  };

  const onDelete = (id) => {
    setPropertyId(id);
    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
    try {
      const { code, message } = await PropertiesApi.deleteSingleLookingFor(
        propertyId
      );
      if (code === 200) {
        toast.success(t("listing_deleted_successfully"));
        setShowDeleteModal(false);
        getLookingForList();
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
    } catch (error) {}
  };

  const handleMarkSold = async (hashId) => {
    try {
      const { code, message } = await PropertiesApi.changePropertyStatus(
        hashId
      );
      if (code === 200) {
        toast.success(t("status_updated_successfully"));
        getLookingForList();
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
    } catch (error) {}
  };
  // const handleCloseModal = () => setShowModal(false);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth < 767);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getAdvertiserTypes = async () => {
    try {
      const response = await PropertiesApi.getListingStatuses();
      setAdvertiserTypes(
        buildAdvertiserRoleOptions(response?.data?.advertiser_types)
      );
    } catch (error) {
      setAdvertiserTypes(buildAdvertiserRoleOptions());
    }
  };

  const getLookingForList = async () => {
    try {
      setIsFetching(true);
      const { data, code } = await PropertiesApi.getLookingForList();
      if (code === 200 && data?.data) {
        setPropertiesList(data?.data);
      } else {
        setPropertiesList([]);
      }
    } catch (error) {
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    getLookingForList();
    getAdvertiserTypes();
  }, [language]);

  return (
    <>
      <Box className="d-flex justify-content-between w-100 align-items-center mb-4">
        <Box className="d-flex gap-2 align-items-center">
          {showAll && (
            <BackArrow
              onClick={() => setShowAll(false)}
              style={{
                transform: language === "ar" ? "scale(-1)" : "scale(1)",
              }}
            />
          )}
          <HeadingStyled size="24px">{t("properties_i_seek")}</HeadingStyled>
        </Box>
        <ButtonStyled
          label={!isDesktop ? t("add_wanted_property") : t("add")}
          icon={!isDesktop && PlusIcon}
          bg="var(--themeColorSecondary)"
          onClick={() => {
            if (isVisitorSpecialization) {
              toast.error(t("visitor_specialization_cannot_publish"));
              return;
            }
            setShowModal(true);
          }}
        />
      </Box>
      {propertiesList.length > 0 ? (
        <Box
          className={`propertiesGridWrapper ${
            showAll && "flex-wrap overflow-visible"
          } `}
        >
          {propertiesList
            .slice(0, showAll ? propertiesList.length : 3)
            .map((item, key) => (
              <Box
                className={`px-1 ${
                  isDesktop && !showAll
                    ? "col-sm-6 col-9"
                    : isDesktop && showAll && "col-12"
                }`}
                key={key}
              >
                <Box className="colPropertiesGrid pb-md-4">
                  <Box className="titleLocationWrapper gap-2 position-relative">
                    <Box className="titleLocation d-flex justify-content-between flex-column gap-2">
                      <HeadingStyled size="18px">{`${t("looking_to")} ${t(
                        item.type
                      )}`}</HeadingStyled>
                      <Box className="d-flex align-items-center">
                        {item?.price && (
                          <Box className="d-flex gap-1 align-items-end">
                            <HeadingStyled className="budget-heading" size="17px">{t("budget")}:</HeadingStyled>
                            <SpanStyled
                              color="var(--darkGrey)"
                              size="17px"
                              className="price-wrapper"
                            >
                              {formateAmounts(item?.price)}
                            </SpanStyled>
                          </Box>
                        )}
                        <Box title={t("more_options")} className="propertyActionDropdown">
                          <ActionDropdown
                            color="var(--darkGrey)"
                            paddingY={5}
                            paddingX={16}
                            itemsList={lookingForDropdownList}
                            property={{}}
                            onEdit={handleOpenModal}
                            onDelete={onDelete}
                            title={<ThreeDots />}
                            hashId={item.id}
                            id={item.id}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box className="peopleLocationRole mt-1">
                    <SpanStyled
                      size="14px"
                      color="var(--lightGrey)"
                      className="d-flex gap-1"
                    >
                      <Box>
                        <LocationPin />
                      </Box>{" "}
                      {item.cities
                        .map((city) =>
                          language === "en" ? city.name_en : city.name_ar
                        )
                        .join(" | ")}
                    </SpanStyled>
                  </Box>
                  <Box className="advIdentityWrapper">
                    <Box className="advIdentityPlatform ">
                      <SpanStyled size="14px" color="var(--lightGrey)">
                        {t("Property_category")}
                      </SpanStyled>
                      <br />
                      <HeadingStyledSm
                        size="14px"
                        color="var(--darkGrey)"
                        className="mt-1"
                      >
                        {t(item.property_category)}
                      </HeadingStyledSm>
                    </Box>
                    <Box className="advIdentityPlatform ">
                      <SpanStyled size="14px" color="var(--lightGrey)">
                        {t("Property_Type")}
                      </SpanStyled>
                      <br />
                      <HeadingStyledSm
                        size="14px"
                        color="var(--darkGrey)"
                        className="mt-1"
                      >
                        {language === "en"
                          ? item.property_type_id.en_name
                          : item.property_type_id.ar_name}
                      </HeadingStyledSm>
                    </Box>
                    {item?.customer_type && (
                      <Box className="advIdentityPlatform ">
                        <SpanStyled size="14px" color="var(--lightGrey)">
                          {t("AdvertiserRoles")}
                        </SpanStyled>
                        <br />
                        <HeadingStyledSm
                          size="14px"
                          color="var(--darkGrey)"
                          className="mt-1"
                        >
                          {resolveAdvertiserRoleLabel(
                            item?.customer_type,
                            advertiserTypes
                          )}
                        </HeadingStyledSm>
                      </Box>
                    )}
                    {item?.bedrooms && (
                      <Box className="advIdentityPlatform ">
                        <SpanStyled size="14px" color="var(--lightGrey)">
                          {t("Bedrooms")}
                        </SpanStyled>
                        <br />
                        <HeadingStyledSm
                          size="14px"
                          color="var(--darkGrey)"
                          className="mt-1"
                        >
                          {item.bedrooms == 10
                            ? "9+"
                            : item.bedrooms == 11
                            ? t("Studio")
                            : item?.bedrooms || "N/A"}
                        </HeadingStyledSm>
                      </Box>
                    )}
                    {!item?.bedrooms && item?.inside_mall_only_bit == 1 && (
                      <Box className="advIdentityPlatform ">
                        <SpanStyled size="14px" color="var(--lightGrey)">
                          {t("Inside_Mall_Only")}
                        </SpanStyled>
                        <br />
                        <HeadingStyledSm
                          size="14px"
                          color="var(--darkGrey)"
                          className="mt-1"
                        >
                          {item?.inside_mall_only_bit == 1 ? t("yes") : t("no")}
                        </HeadingStyledSm>
                      </Box>
                    )}
                    {/* <Box className="advIdentityPlatform col-5 col-lg-3">
                      <SpanStyled size="14px" color="var(--lightGrey)">
                        {t("Price_Range")}
                      </SpanStyled>
                      <br />
                      <HeadingStyledSm
                        size="14px"
                        color="var(--darkGrey)"
                        className="mt-1"
                      >
                        {item.price}
                      </HeadingStyledSm>
                    </Box> */}
                  </Box>
                  <Box className="d-flex justify-content-end mt-3">
                    <Box
                      className="d-flex align-items-center contact-btn gap-1"
                      style={{ cursor: "pointer" }}
                    >
                      <Whatsapp width={25} height={24} />
                      <SpanStyled color="var(--themeColorSecondary)">
                        {t("contact_us")}
                      </SpanStyled>
                    </Box>
                  </Box>
                </Box>
              </Box>
            ))}
          {/* {propertiesList
            .slice(0, showAll ? propertiesList.length : 3)
            .map((item, key) => (
              <Box
                className={`px-1 ${
                  isDesktop && !showAll
                    ? "col-sm-6 col-9"
                    : isDesktop && showAll && "col-12"
                }`}
                key={key}
              >
                <Box className="colPropertiesGrid">
                  <Box className="titleLocationWrapper">
                    <Box className="titleLocation">
                      <HeadingStyled size="18px">
                        {t("Listing to buy")}
                      </HeadingStyled>
                      <Box className="peopleLocationRole mt-1">
                        <SpanStyled
                          size="14px"
                          color="var(--lightGrey)"
                          className="d-flex align-items-center gap-1"
                        >
                          <LocationPin /> {t("Riyadh, Jeddah")}
                        </SpanStyled>
                        <SpanStyled size="14px" color="var(--lightGrey)">
                          {t("Al Olaya District")}
                        </SpanStyled>
                      </Box>
                    </Box>
                    <Box className="propertyActionDropdown">
                      <ActionDropdown
                        color="var(--darkGrey)"
                        paddingY={5}
                        paddingX={16}
                        itemsList={PropertyDropdownList}
                        property={{}}
                        onEdit={handleOpenModal}
                        onDelete={onDelete}
                        onStatusChange={handleMarkSold}
                        title={<ThreeDots />}
                        hashId={"12345"}
                        id={1}
                      />
                    </Box>
                  </Box>

                  <Box className="advIdentityWrapper">
                    <Box className="advIdentityPlatform col-5 col-lg-3">
                      <SpanStyled size="14px" color="var(--lightGrey)">
                        {t("Property Category")}
                      </SpanStyled>
                      <br />
                      <HeadingStyledSm
                        size="14px"
                        color="var(--darkGrey)"
                        className="mt-1"
                      >
                        {t("Residential")}
                      </HeadingStyledSm>
                    </Box>
                    <Box className="advIdentityPlatform col-5 col-lg-3">
                      <SpanStyled size="14px" color="var(--lightGrey)">
                        {t("Property Types")}
                      </SpanStyled>
                      <br />
                      <HeadingStyledSm
                        size="14px"
                        color="var(--darkGrey)"
                        className="mt-1"
                      >
                        {t("Apartment, Penthouse")}
                      </HeadingStyledSm>
                    </Box>
                    <Box className="advIdentityPlatform col-5 col-lg-3">
                      <SpanStyled size="14px" color="var(--lightGrey)">
                        {t("Bedrooms")}
                      </SpanStyled>
                      <br />
                      <HeadingStyledSm
                        size="14px"
                        color="var(--darkGrey)"
                        className="mt-1"
                      >
                        {t("3")}
                      </HeadingStyledSm>
                    </Box>
                    <Box className="advIdentityPlatform col-5 col-lg-3">
                      <SpanStyled size="14px" color="var(--lightGrey)">
                        {t("Ad Number")}
                      </SpanStyled>
                      <br />
                      <HeadingStyledSm
                        size="14px"
                        color="var(--darkGrey)"
                        className="mt-1"
                      >
                        {t("A12345")}
                      </HeadingStyledSm>
                    </Box>
                    <Box className="advIdentityPlatform col-5 col-lg-3">
                      <SpanStyled size="14px" color="var(--lightGrey)">
                        {t("Price Range (SAR)")}
                      </SpanStyled>
                      <br />
                      <HeadingStyledSm
                        size="14px"
                        color="var(--darkGrey)"
                        className="mt-1"
                      >
                        {t("100,000 - 150,000")}
                      </HeadingStyledSm>
                    </Box>
                  </Box>
                </Box>
              </Box>
            ))} */}
        </Box>
      ) : (
        <Box className="d-flex justify-content-center">
          <HeadingStyled>{t("no_listing_found")}</HeadingStyled>
        </Box>
      )}
      {!showAll && propertiesList.length > 3 && (
        <Box className="w-100 d-flex justify-content-center mt-2">
          <ButtonStyled
            label={t("ViewAll")}
            iconAfter={language == "en" ? BackwardArrow : ForwardArrow}
            bg="var(--white)"
            border="var(--border)"
            color="var(--themeColorSecondary)"
            onClick={() => setShowAll(true)}
          />
        </Box>
      )}
      <AddLookingForModal
        show={showModal}
        onHide={() => setShowModal(false)}
        getLookingForList={getLookingForList}
      />
      <EditLookingForModal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        getLookingForList={getLookingForList}
        id={propertyId}
        setId={setPropertyId}
      />
      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={handleDelete}
        title={t("property")}
      />
    </>
  );
};

export default LookingForCards;
